import React from "react";

// Components
import { InputNumber as InputNumberBase } from "antd";
import { Label, Text } from "../Input/Input.styles";
import { InputWrapper } from "./InputNumber.styles";

interface Props {
  label?: string;
  placeholder?: string;
  dimension?: string;
  required?: boolean;
  textarea?: boolean;
  disabled?: boolean;
  defaultValue?: number;
  handleChange: (value?: string | number) => void;
  formatter?: (value?: string | number) => string;
  parser?: (value?: string) => React.ReactText;
  currency?: boolean;
  displayOnly?: boolean;
  precision?: number;
  disallowedCharacters?: string[];
}

const InputNumber: React.FC<Props> = ({
  label,
  placeholder,
  dimension,
  disabled,
  defaultValue,
  handleChange,
  formatter,
  parser,
  displayOnly,
  precision,
  disallowedCharacters = [],
}) => {
  const validateIntegerInput = (e: React.KeyboardEvent<HTMLInputElement>, disallowedCharacters: string[]) => {
    if (disallowedCharacters.includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <InputWrapper disabled={disabled}>
      {displayOnly ? (
        <>
          <Label>{label}</Label>
          <Text>{`${defaultValue} ${dimension === "inches" ? "in" : dimension}`}</Text>
        </>
      ) : (
        <>
          <InputNumberBase
            onFocus={(e) => e.target.select()}
            disabled={disabled}
            placeholder={placeholder}
            defaultValue={defaultValue}
            onBlur={(e) => {
              const parsedValue = parser ? parser(`${e.target.value}`) : e.target.value;
              handleChange(parsedValue);
            }}
            onKeyDown={(e) => validateIntegerInput(e, disallowedCharacters)}
            min={0}
            formatter={formatter}
            parser={parser}
            precision={precision}
            type="number"
          />
          <Label dimension>{label}</Label>{" "}
        </>
      )}
    </InputWrapper>
  );
};
export default InputNumber;
